export const preferredDays = [
  { id: 'monday', value: 'monday', label: 'Monday' },
  { id: 'tuesday', value: 'tuesday', label: 'Tuesday' },
  { id: 'wednesday', value: 'wednesday', label: 'Wednesday' },
  { id: 'thursday', value: 'thursday', label: 'Thursday' },
  { id: 'friday', value: 'friday', label: 'Friday' },
  { id: 'saturday', value: 'saturday', label: 'Saturday' },
  { id: 'sunday', value: 'sunday', label: 'Sunday' },
]; 